import { isDefined, MaterialModel } from '@evorait/pace-core';

export interface BootstockReturnResponseInterface {
    materialNumber: string;
    isReturnable: boolean;
}

export enum BOOTSTOCK_RETURN_ACTION {
    RETURN = 'Return',
    SCRAP = 'Scrap',
    NONE = 'None',
}

/**
 * Resolves the bootstock return action for a material based on the Snowflake bootstockReturnIds lookup,
 * falling back to the P58 scrappable flag when the material wasn't returned by Snowflake.
 *
 * @param material the material to get the action for
 * @param bootStockReturnIds map of (8-char padded) material numbers to return status
 * @returns the bootstock return action
 */
export function getBootstockReturnAction(
    material: MaterialModel,
    bootStockReturnIds: Map<string, boolean>,
): BOOTSTOCK_RETURN_ACTION {
    const materialNumber = material.materialIdentifier.materialNumber.value.padStart(8, '0');
    const returnValue = bootStockReturnIds.get(materialNumber);

    if (!isDefined(returnValue)) {
        return material.isBootStockScrapable ? BOOTSTOCK_RETURN_ACTION.SCRAP : BOOTSTOCK_RETURN_ACTION.NONE;
    }

    return returnValue ? BOOTSTOCK_RETURN_ACTION.RETURN : BOOTSTOCK_RETURN_ACTION.SCRAP;
}
